import type { Curso } from '../domain/types';

/**
 * Banda superior de la tarjeta de curso, portada de `bannerSVG()` de la demo: degradado del
 * curso con tres círculos translúcidos.
 *
 * El id del degradado lleva el id del curso porque en un SVG los `<defs>` son globales al
 * documento: con cuatro tarjetas en pantalla y todas usando `id="g"`, las cuatro tomarían
 * el degradado de la primera.
 */
export function BannerCurso({ curso, children }: { curso: Curso; children?: React.ReactNode }) {
  const idGrad = `grad-${curso.id}`;
  return (
    <div className="relative h-[120px] overflow-hidden">
      <svg
        viewBox="0 0 400 120"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-full"
      >
        <defs>
          <linearGradient id={idGrad} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={curso.gradiente1} />
            <stop offset="1" stopColor={curso.gradiente2} />
          </linearGradient>
        </defs>
        <rect width="400" height="120" fill={`url(#${idGrad})`} />
        <circle cx="350" cy="10" r="70" fill="#fff" opacity=".12" />
        <circle cx="30" cy="115" r="50" fill="#fff" opacity=".1" />
        <circle cx="300" cy="100" r="26" fill="#fff" opacity=".1" />
      </svg>
      <span className="absolute bottom-3 left-5 text-4xl leading-none drop-shadow-md">
        {curso.emoji}
      </span>
      {children}
    </div>
  );
}
